import types from "../index";

function setUserId(id) {
    return {
        type: types.DASHBOARD_SET_USER_ID,
        id,
    }
}

function setUser(user) {
    return {
        type: types.DASHBOARD_SET_USER,
        user,
    }
}

function setSubscription(subscription) {
    return {
        type: types.DASHBOARD_SET_SUBSCRIPTION,
        subscription,
    }
}

function loadHistory(history) {
    return {
        type: types.DASHBOARD_LOAD_HISTORY,
        history,
    }
}

const actions = {
    setUserId,
    setUser,
    setSubscription,
    loadHistory,
}

export default actions;
